module.exports = __webpack_public_path__ + "static/media/astronaut_astroid_isolated.4d2878ca.png";